module.exports = __webpack_public_path__ + "img/creative-commons-sampling-plus.f8552efe.svg";